<template>
   <div class="brand-item-c" :class="[brand.selected ? 'selected-brand' : '', isActive ? 'on-spot' : '']" :style="{ width: width }" @click="handleBrandClick">
      <!-- Badges Container -->
      <div class="badges-container masked">
         <div class="recommended-badge" v-if="brand.selected">
            {{ $t("flightBrands_lblBrandSelected") }}
            <span class="mix-badge-inner" v-if="Array.isArray(BrandTitle)">{{ $t("Mix") }}</span>
         </div>
         <div class="mix-badge" v-else-if="Array.isArray(BrandTitle)">{{ $t("Mix") }}</div>
      </div>

      <!-- Brand Header - HTML line 79-85 -->
      <section class="brand-item-header" v-if="!Array.isArray(BrandTitle) || !showFeatures">
         <!-- <span class="brand-item-category">{{ brand.flightClass }}</span> -->
         <template v-if="Array.isArray(BrandTitle)">
            <span class="brand-item-title" v-for="(title, index) in BrandTitle" :key="index"> {{ title }} </span>
         </template>
         <span v-else class="brand-item-title">{{ BrandTitle }}</span>
         <div class="brand-price-calculate" v-if="brand.estimatedPrice && !brand.selected">
            <button class="calculate-price-btn" @click.stop="handleBrandClick">
               {{ $t("flightBrands_lblBrandCalculate") }}
            </button>
         </div>
         <div class="brand-price" v-else>
            <span class="price-amount">{{ brand.total | price(brand.currency) }}</span>
         </div>
      </section>

      <!-- Baggage Info - HTML line 88-95 -->
      <section class="brand-info-wrapper">
         <div class="baggage-box" v-if="brand.baggageInfo != '-1KG'">
            <template v-if="brand.brandCode == 'SUPER_ECOLIGHT'">
               <i class="gts-icon icon-brand-hand-wallet"></i>
            </template>
            <template v-else-if="brand.brandCode == 'LIGHT_PDBG'">
               <i class="gts-icon icon-brand-cabin-baggage"></i>
            </template>
            <template v-else>
               <i class="gts-icon icon-brand-baggage"></i>
            </template>
            <span>{{ brand.baggageInfo }}</span>
         </div>
         <div class="baggage-box disabled" v-else>
            <i class="gts-icon icon-brand-baggage"></i>
            <span>{{ $t("flightBrands_lblBaggageInfoUnknown") }}</span>
         </div>

         <!-- Toggle Features Button -->
         <template v-if="brand.ssrs.length > 0">
            <button class="toggle-features-btn" @click.stop="$emit('toggle-features')" :class="{ rotated: showFeatures }"><i class="gts-icon icon-arrow-down icon-sm"></i></button>
         </template>
      </section>

      <!-- Brand Details - Cross-brand -->
      <div v-if="(showFeatures || brand.baggageInfo == '-1KG') && SeparatedBrandFeatures" class="separated-brands-container">
         <div v-for="(separatedBrand, brandIdx) in SeparatedBrandFeatures" :key="brandIdx" class="separated-brand-section">
            <div class="separated-brand-header">
               <span class="separated-brand-title">{{ separatedBrand.title.trimmer(15) }}</span>
               <span class="separated-brand-route">{{ separatedBrand.route }}</span>
            </div>
            <section class="brand-details-wrapper" :ref="`featuresContainer${brandIdx}`" @scroll="handleFeaturesScroll">
               <ul>
                  <li v-for="(ssr, ssrIndex) in separatedBrand.ssrs" :key="ssrIndex">
                     <i class="gts-icon icon-brand-item-check masked-hidden icon-sm" v-if="ssr.state == 1"></i>
                     <i class="gts-icon icon-brand-item-x masked-hidden icon-sm" v-else></i>
                     {{ ssr.info }}
                  </li>
               </ul>
            </section>
         </div>
      </div>

      <!-- Brand Details - Normal -->
      <section v-else-if="showFeatures || brand.baggageInfo == '-1KG'" class="brand-details-wrapper" ref="featuresContainer" @scroll="handleFeaturesScroll">
         <ul>
            <li v-for="(ssr, ssrIndex) in brand.ssrs" :key="ssrIndex">
               <i class="gts-icon icon-brand-item-check masked-hidden icon-sm" v-if="ssr.state == 1"></i>
               <i class="gts-icon icon-brand-item-x masked-hidden icon-sm" v-else></i>
               {{ ssr.info }}
            </li>
         </ul>
      </section>

      <!-- CTA Button - HTML line 115-117 -->
      <section class="brand-cta-wrapper">
         <button @click.stop="handleBrandClick" :disabled="brand.selected">
            {{ brand.selected ? $t("flightBrands_lblBrandSelected") : $t("flightBrands_lblBrandSelect") }}
         </button>
      </section>
   </div>
</template>

<script>
import Popup from "@/gts-popup.js";
import { flightService } from "@/service/index.js";

export default {
   name: "BrandItem",
   props: {
      brand: {
         type: Object,
         required: true,
      },
      isActive: {
         type: Boolean,
         default: false,
      },
      flightIdentifier: {
         type: String,
         required: true,
      },
      pricePerLeg: {
         type: Boolean,
         default: false,
      },
      data: {
         type: Object,
         default: () => ({}),
      },
      width: {
         type: String,
         default: "280px",
      },
      showFeatures: {
         type: Boolean,
         default: false,
      },
      featuresScrollTop: {
         type: Number,
         default: 0,
      },
   },
   data() {
      return {
         showSsr: true,
         isSyncingScroll: false,
         scrollThrottleTimer: null,
      };
   },
   computed: {
      BrandTitle() {
         const hasCrossBrand = this.$store.state.flight.checkout.response.hasCrossBrand;
         const title = this.brand.brandTitle;

         // hasCrossBrand false ise array dönmemeli, her zaman brandName dön
         if (!hasCrossBrand) {
            return this.brand.brandTitle;
         }

         // hasCrossBrand true ise normal logic
         if (title.includes("&")) {
            const parts = title.split("&").map((part) => part.trim());

            if (parts[0] === parts[1]) {
               return this.brand.brandTitle;
            }

            return parts; // Array dön
         }

         return title;
      },
      SeparatedBrandFeatures() {
         // Cross-brand durumunda her leg için ayrı brand bilgisi
         const hasCrossBrand = this.$store.state.flight.checkout.response.hasCrossBrand;

         if (!hasCrossBrand || !Array.isArray(this.BrandTitle)) {
            return null;
         }

         const parts = this.BrandTitle; // ["Premium Economy Flex Plus", "Economy Saver"]
         const separatedBrands = [];

         Object.keys(this.data).forEach((legKey, idx) => {
            const leg = this.data[legKey];
            const sameBrandInThisLeg = Object.values(leg.brands).find((b) => b.index === this.brand.index);

            if (sameBrandInThisLeg && sameBrandInThisLeg.brandName === parts[idx]) {
               separatedBrands.push({
                  title: sameBrandInThisLeg.brandName,
                  route: leg.route,
                  ssrs: sameBrandInThisLeg.ssrs || [],
                  features: sameBrandInThisLeg.features || [],
               });
            }
         });

         return separatedBrands;
      },
   },
   methods: {
      handleBrandClick() {
         if (this.brand.selected) return;
         this.handlerSelectBrand(this.brand.identifier, this.flightIdentifier);
      },

      handleFeaturesScroll(event) {
         // Don't emit if we're currently syncing from parent
         if (this.isSyncingScroll) return;

         const scrollTop = event.target.scrollTop;

         // Use requestAnimationFrame for smooth updates
         if (this.scrollThrottleTimer) {
            cancelAnimationFrame(this.scrollThrottleTimer);
         }

         this.scrollThrottleTimer = requestAnimationFrame(() => {
            this.$emit("features-scroll", scrollTop);
         });
      },

      handlerSelectBrand(brandId, flightID) {
         const self = this;

         const flightsExtraSsrs = self.$store.state.flight.checkout.request.flightsExtraSsrs;
         const hasExtraSsrs = flightsExtraSsrs && Object.keys(flightsExtraSsrs).length > 0;

         const doSelectBrand = () => {
            self.showSsr = false;
            self.$store.commit("app/setIsProgressGifActive", true);
            self.$store.state.app.progress.message = self.$i18n.t("flightCheckout_brandSelection");

            if (!self.pricePerLeg) {
               var selectedBrandIndex;
               const arrBrands = {};

               //Find Selected Brand Index
               Object.keys(self.data).forEach((leg) => {
                  arrBrands[self.data[leg].flightIdentifier] = arrBrands[self.data[leg].flightIdentifier];
                  Object.keys(self.data[leg].brands).forEach((brand, brandIndex) => {
                     if (brand == brandId) {
                        selectedBrandIndex = brandIndex;
                     }
                  });
               });

               //Generate ArrBrands with identifiers
               Object.keys(self.data).forEach((leg) => {
                  Object.keys(self.data[leg].brands).forEach((brand, brandIndex) => {
                     if (brandIndex == selectedBrandIndex) {
                        arrBrands[self.data[leg].flightIdentifier] = brand;
                     }
                  });
               });

               self.$store.commit("flight/updateCheckoutBrandsPackage", arrBrands);
            } else {
               self.$store.commit("flight/updateCheckoutBrands", {
                  flightIdentifier: brandId,
                  identifier: flightID,
               });
            }

            self.$store.commit("flight/deleteCheckoutSsrs", self.flightIdentifier);

            let query = self.$store.state.flight.checkout.request;

            flightService.checkout(query).then((response) => {
               self.$store.commit("flight/updateCheckoutResponse", response.checkoutResponse);
               self.$store.commit("flight/updateCheckoutRequest", response.checkoutRequest);
               self.$store.commit("flight/updateCheckoutUuid", response.checkoutUuid);
               self.showSsr = true;
               self.$store.commit("app/setIsProgressGifActive", false);
               self.$store.state.app.progress.message = "";
               self.$emit("brand-selected");
            });
         };

         if (hasExtraSsrs) {
            const title = self.$i18n.t("flightBrands_lblBrandChangeTitle");
            const subTitle = self.$i18n.t("flightBrands_lblBrandChangeSubtitle");
            Popup.confirm(title, subTitle, null, "customCancel").then((result) => {
               if (result.success) {
                  doSelectBrand();
               }
            });
         } else {
            doSelectBrand();
         }
      },
   },
   watch: {
      featuresScrollTop(newScrollTop) {
         // Handle both single container and multiple containers (cross-brand)
         const containers = [];

         // Check for single container
         if (this.$refs.featuresContainer) {
            containers.push(this.$refs.featuresContainer);
         }

         // Check for cross-brand containers
         if (this.SeparatedBrandFeatures) {
            this.SeparatedBrandFeatures.forEach((_, idx) => {
               const container = this.$refs[`featuresContainer${idx}`];
               if (container && container[0]) {
                  containers.push(container[0]);
               }
            });
         }

         if (containers.length === 0) return;

         // Set flag before syncing
         this.isSyncingScroll = true;

         // Sync all containers
         containers.forEach((container) => {
            // Only sync if the scroll position is actually different
            if (Math.abs(container.scrollTop - newScrollTop) < 1) return;
            container.scrollTop = newScrollTop;
         });

         // Clear flag on next frame
         requestAnimationFrame(() => {
            this.isSyncingScroll = false;
         });
      },
   },
};
</script>

<style lang="scss" scoped>
$brandPadding: 1.25rem;

.brand-item-c {
   background: linear-gradient(145deg, var(--gray-0), var(--gray-100));
   box-shadow: 0 10px 15px -3px color-mix(in srgb, var(--gray-1000) 5%, transparent), 0 4px 6px -2px color-mix(in srgb, var(--gray-1000) 2%, transparent),
      inset 0 1px 0 0 color-mix(in srgb, var(--gray-0) 80%, transparent);
   border-radius: 1.5rem;
   padding: $brandPadding;
   cursor: pointer;
   transition: all 0.3s ease;
   width: 280px;
   max-width: 100%;
   flex-shrink: 0;
   position: relative;
   display: flex;
   flex-direction: column;
   border: 1px solid var(--gray-200);
   box-sizing: border-box;

   .badges-container {
      position: absolute;
      top: -1rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 20;
   }

   .recommended-badge {
      background-color: var(--accent-primary);
      color: var(--txt-white);
      font-size: 0.625rem;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: 0.2em;
      padding: 0.375rem 1rem;
      border-radius: 9999px;
      box-shadow: 0 10px 15px -3px color-mix(in srgb, var(--accent-primary) 40%, transparent);
      white-space: nowrap;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;

      .mix-badge-inner {
         background-color: var(--yellow-300);
         // background-color: var(--gray-0);
         color: var(--gray-900);
         font-size: 0.5rem;
         font-weight: 900;
         text-transform: uppercase;
         letter-spacing: 0.15em;
         padding: 0.2rem 0.5rem;
         border-radius: 9999px;
         // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
      }
   }

   .mix-badge {
      background-color: var(--yellow-400);
      color: var(--gray-900);
      font-size: 0.625rem;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: 0.2em;
      padding: 0.375rem 1rem;
      border-radius: 9999px;
      box-shadow: 0 10px 15px -3px color-mix(in srgb, var(--yellow-400) 40%, transparent);
      white-space: nowrap;
   }

   &:hover {
      transform: translateY(-4px);
      box-shadow: 0 20px 25px -5px color-mix(in srgb, var(--gray-1000) 10%, transparent), 0 10px 10px -5px color-mix(in srgb, var(--gray-1000) 4%, transparent),
         inset 0 1px 0 0 color-mix(in srgb, var(--gray-0) 90%, transparent);
   }

   &.on-spot {
      transform: translateY(-4px);
   }

   &.selected-brand {
      background: linear-gradient(145deg, var(--gray-0), var(--surface-level-2, var(--gray-100)));
      background: var(--blue-0);
      border: 2px solid var(--accent-primary);
      box-shadow: 0 20px 25px -5px color-mix(in srgb, var(--gray-1000) 10%, transparent), 0 10px 10px -5px color-mix(in srgb, var(--gray-1000) 4%, transparent),
         inset 0 1px 0 0 color-mix(in srgb, var(--gray-0) 90%, transparent);
      transform: scale(1.05);

      z-index: 10;

      .brand-details-wrapper {
         ul {
            li {
               &:nth-child(odd) {
                  background-color: var(--gray-0);
               }
               &:nth-child(even) {
                  background-color: var(--blue-0);
                  border: 1px solid var(--blue-100);
               }
            }
         }
      }

      .brand-item-header {
         .brand-item-category {
            color: var(--accent-primary);
         }
      }

      .brand-cta-wrapper button {
         background: var(--accent-primary) !important;
         color: var(--txt-white) !important;
         box-shadow: 0 10px 15px -3px color-mix(in srgb, var(--accent-primary) 30%, transparent) !important;
         border: none !important;

         &:hover {
            background: var(--gray-900);
         }
      }
   }

   .brand-item-header {
      margin-top: 0.5rem;
      margin-bottom: 1rem;
      line-height: 2rem;
      display: flex;
      flex-direction: column;
      align-items: center;

      .brand-item-category {
         color: var(--gray-400);
         font-size: 0.75rem;
         font-weight: 900;
         text-transform: uppercase;
         letter-spacing: 0.1em;
         margin-bottom: 0.25rem;
         display: block;
      }

      .brand-item-title {
         color: var(--gray-800);
         font-weight: 500;
         font-size: var(--large);
         line-height: 1.25rem;

         text-align: center;
         display: block;
      }

      .brand-price {
         display: flex;
         align-items: baseline;
         gap: 0.25rem;
         margin-top: 0.75rem;

         .price-amount {
            color: var(--gray-900);
            font-size: var(--xxlarge);
            font-weight: 900;
         }

         .price-label {
            color: var(--gray-400);
            font-size: 0.875rem;
            font-weight: 700;
            text-transform: uppercase;
         }
      }

      .brand-price-calculate {
         display: flex;
         justify-content: center;
         margin-top: 0.5rem;

         .calculate-price-btn {
            padding: 0.625rem 1.5rem;
            border-radius: 0.75rem;
            font-size: 0.875rem;
            font-weight: 700;
            background: linear-gradient(145deg, var(--gray-100), var(--gray-200));
            color: var(--gray-600);
            border: 1px solid var(--gray-300);
            transition: all 0.3s ease;

            &:hover {
               background: linear-gradient(145deg, var(--accent-primary), color-mix(in srgb, var(--accent-primary) 90%, black));
               color: var(--txt-white);
               border-color: var(--accent-primary);
            }
         }
      }
   }

   section.brand-info-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      padding: 0 1rem;

      .baggage-box {
         display: flex;
         align-items: center;
         gap: 0.5rem;

         i.icon-brand-baggage {
            flex-shrink: 0;
            width: 36px !important;
            height: 54px !important;
         }

         span {
            color: var(--gray-700);
            font-size: var(--large);
            font-weight: 500;
         }

         &.disabled {
            opacity: 0.5;

            span {
               font-style: italic;
            }
         }
      }

      button.toggle-features-btn {
         width: 38px !important;
         height: 38px !important;
         display: flex;
         align-items: center;
         justify-content: center;
         background: var(--gray-300);
         border-radius: 50%;
         transition: all 0.3s ease;
         flex-shrink: 0;
         box-sizing: border-box;

         &.rotated {
            transform: rotate(180deg);
         }

         &:hover {
            background: linear-gradient(145deg, var(--gray-200), var(--gray-300));
         }
      }

      .brand-info-inner-wrapper {
         display: flex;
         align-items: center;
         justify-content: space-between;
         gap: 1rem;
         width: 100%;

         i.icon-brand-item-baggage,
         i.icon-brand-hand-wallet,
         i.icon-brand-cabin-baggage {
            flex-shrink: 0;
         }

         i.icon-brand-item-baggage {
            width: 52px !important;
            height: 64px !important;
         }

         .brand-info-text-wrapper {
            display: flex;
            flex-direction: column;
            flex: 1;
            text-align: center;

            span {
               &.brand-info-text-baggage-info {
                  font-size: 0.875rem;
                  font-weight: 500;
                  color: var(--gray-700);
               }

               &.brand-info-text-price {
                  font-size: 3rem;
                  font-weight: 900;
                  color: var(--gray-900);
               }

               &.baggage-unknown {
                  background-color: var(--red-500);
                  color: var(--txt-white);
                  padding: 0.25rem 0.75rem;
                  border-radius: 0.5rem;
                  font-size: 0.75rem;
                  font-weight: 700;
                  text-transform: uppercase;
                  display: inline-block;
               }
            }

            .brand-total-calculate {
               border-radius: 0.75rem;
               padding: 0.75rem 1.5rem;
               font-size: 1rem;
               font-weight: 700;
               background: linear-gradient(145deg, var(--gray-100), var(--gray-200));
               color: var(--gray-500);
               margin-top: 0.5rem;
               border: 1px solid color-mix(in srgb, var(--gray-0) 60%, transparent);
               box-shadow: 0 4px 6px -1px color-mix(in srgb, var(--gray-1000) 10%, transparent), inset 0 1px 0 0 color-mix(in srgb, var(--gray-0) 80%, transparent);

               &:hover {
                  background: linear-gradient(145deg, var(--gray-200), var(--gray-400));
                  color: var(--txt-white);
               }
            }
         }

         button.toggle-details-btn {
            width: 32px !important;
            height: 32px !important;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(145deg, var(--gray-100), var(--gray-200));
            border: 1px solid color-mix(in srgb, var(--gray-0) 60%, transparent);
            box-shadow: 0 4px 6px -1px color-mix(in srgb, var(--gray-1000) 10%, transparent), inset 0 1px 0 0 color-mix(in srgb, var(--gray-0) 80%, transparent);
            border-radius: 50%;
            transition: all 0.3s ease;
            flex-shrink: 0;

            &.brand-features-visible {
               transform: rotate(180deg);
            }

            &:hover {
               background: linear-gradient(145deg, var(--gray-200), var(--gray-300));
            }
         }
      }
   }

   .separated-brands-container {
      display: flex;
      gap: 1rem;
      margin: 0.5rem 0;
      width: 100%;
   }

   .separated-brand-section {
      flex: 1;
      min-width: 0;

      &:not(:last-child) {
         padding-right: 1rem;
         border-right: 2px dashed var(--gray-300);
      }

      .separated-brand-header {
         display: flex;
         flex-direction: column;
         gap: 0.25rem;
         margin: 0.5rem 0;
         padding: 0.5rem;
         background: var(--blue-100);
         border: 1px solid var(--blue-300);
         border-radius: 0.5rem;
         line-height: 0.75rem;

         .separated-brand-title {
            font-size: 0.875rem;
            font-weight: 700;
            color: var(--blue-700) !important;
         }

         .separated-brand-route {
            font-size: 0.75rem;
            font-weight: 500;
            color: var(--blue-700) !important;
         }
      }
   }

   section.brand-details-wrapper {
      flex: 1;
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      margin: 0.5rem 0;

      &::-webkit-scrollbar {
         width: 6px;
      }

      &::-webkit-scrollbar-track {
         background: color-mix(in srgb, var(--gray-1000) 3%, transparent);
         border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
         background: color-mix(in srgb, var(--gray-1000) 15%, transparent);
         border-radius: 10px;

         &:hover {
            background: color-mix(in srgb, var(--gray-1000) 25%, transparent);
         }
      }

      ul {
         display: flex;
         flex-direction: column;

         li {
            display: flex;
            align-items: flex-start;
            gap: 0.5rem;
            font-size: 0.875rem;
            color: var(--gray-600);
            padding: 0.25rem 0.5rem;
            margin: 0.125rem 0;
            border-radius: 0.5rem;

            &:nth-child(odd) {
               background-color: var(--gray-100);
            }
            &:nth-child(even) {
               border: 1px solid var(--gray-100);
            }

            i.gts-icon {
               font-size: 1.25rem;
               font-weight: 700;
               flex-shrink: 0;

               &.icon-brand-item-check {
                  color: var(--green-600);
               }

               &.icon-brand-item-x {
                  color: var(--red-500);
               }
            }
         }
      }
   }

   section.brand-cta-wrapper {
      margin-top: 1rem;
      display: flex;

      width: 100%;
      button {
         width: 100%;
         padding: 0.75rem 1.5rem;
         border-radius: 1rem;
         background-color: var(--gray-200);
         color: var(--gray-900);
         font-weight: 700;
         font-size: 1rem;
         transition: all 0.3s ease;

         &:hover:not(:disabled) {
            background: var(--accent-primary);
            color: var(--txt-white);
         }

         &:disabled {
            cursor: not-allowed;
         }
      }
   }
}
</style>
